/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UnlinkedPaymentsTotalDto
 */
export interface UnlinkedPaymentsTotalDto {
    /**
     * 
     * @type {string}
     * @memberof UnlinkedPaymentsTotalDto
     */
    total: string;
}

/**
 * Check if a given object implements the UnlinkedPaymentsTotalDto interface.
 */
export function instanceOfUnlinkedPaymentsTotalDto(value: object): value is UnlinkedPaymentsTotalDto {
    if (!('total' in value) || value['total'] === undefined) return false;
    return true;
}

export function UnlinkedPaymentsTotalDtoFromJSON(json: any): UnlinkedPaymentsTotalDto {
    return UnlinkedPaymentsTotalDtoFromJSONTyped(json, false);
}

export function UnlinkedPaymentsTotalDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UnlinkedPaymentsTotalDto {
    if (json == null) {
        return json;
    }
    return {
        
        'total': json['total'],
    };
}

export function UnlinkedPaymentsTotalDtoToJSON(value?: UnlinkedPaymentsTotalDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'total': value['total'],
    };
}

